<template>
  <div class="page">
    <div class="bosch_logo">
      <img src="../../assets/images/activity/question2021-bg.png" />
    </div>
    <div class="content">
      <div v-for="(option, index) in optionList" :key="index">
        <div style="background-color:#ffffff; margin-bottom:15px;border-radius:2px">
          <div class="bar_title">
            <div class="title-icon">
              <img src="../../assets/images/header-icon.png"/>
              <span>{{ index + 1}}</span>
            </div>
            <div class="title">
              <span>{{ option.title }}</span>
            </div>

            <div class="questionType" v-show="option.questionType !== '04'">{{ typeText(option.questionType,option.isRank) }}</div>
          </div>
          <!-- 单选 -->
          <div v-if="option.questionType === '01'">
            <!-- 单选没有文本框 -->
            <div v-if="!option.starType">
              <van-radio-group v-model="option.index">
                <van-cell-group>
                  <van-cell v-for="(item, i) in option.item" :key="i" :name="i">
                    <van-radio :name="i">{{ item.optionName }}</van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
            <!-- 单选含有文本框 -->
            <div v-if="option.starType === 'input'">
              <van-radio-group v-model="option.index" @change="option.content = ''">
                <van-cell-group>
                  <van-cell v-for="(item, idx) in option.item"
                      :key="idx"
                      :label="idx">
                    <van-radio :name="idx" >
                      {{ item.optionName }}
                    </van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <van-cell>
                <van-field v-model="option.content"
                      v-show="option.item && option.index === option.item.length - 1"
                      :placeholder="option.tip"
                      clearable>
                  </van-field>
              </van-cell>
            </div>
          </div>
          <!-- 多选 -->
          <div v-if="option.questionType === '02'">
            <!--排序-->
            <div v-if="option.isRank">
              <van-cell-group>
                <van-cell class="rank"
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <span class="optionName">{{item.optionName}}</span>
                  <span class="rank-input">(
                    <van-field v-model="item.value"  @change.native="handleInputChange($event,index,i)"  />
                  )
                     </span>

                </van-cell>
              </van-cell-group>
            </div>

            <div v-else>
              <van-checkbox-group v-model="option.list">
              <van-cell-group>
                <van-cell
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <van-checkbox shape="square" :name="i">{{ item.optionName }}</van-checkbox>
                </van-cell>
              </van-cell-group>
             </van-checkbox-group>
            </div>
          </div>

          <!-- 问答 -->
          <div v-if="option.questionType === '04'">
            <!--排序-->
          <!-- <div v-if="option.isRank" >
              <van-cell-group>
                <van-cell class="rank"
                  v-for="(item, i) in option.item"
                  :key="i" :name="i"
                  clickable>
                  <span class="rank-box" @click="handleRank(option,item)">
                    <span v-show="item.rank">{{item.rank}}</span></span>
                  <span class="optionName">{{item.optionName}}</span>
                </van-cell>
              </van-cell-group>
          </div> -->

          <div style="padding: 0 10px 10px 10px;" class="score-field">
            <van-field
              v-model="option.questionAdvice"
              type="textarea"
              :placeholder="option.tip"
              autosize
              clearable
            ></van-field>
          </div>
          </div>

          <!-- 评分 -->
          <div v-if="option.questionType === '03'" >

            <!-- 评分星星-->
            <div v-if="option.rateStar" >
              <van-rate v-model="option.rateValue" class="rate-score" />
              <span v-if="option.rateValue > 0" class="rate-evaluation">{{ option.rateTexts[option.rateValue - 1] }}</span>
            </div>

            <!--滑块-->
            <div v-if="option.isSlider" class="slider"  >
              <van-slider  v-model="option.rateValue" :max="10" button-size="18px" @change="onChange" />
              <div class="slider-text">
                <span>完全不可能</span>
                <span>极有可能</span>
              </div>
            </div>

            <div v-if="!option.rateStar&&!option.isSlider">
              <div  class="score-content">
              <div class="score" v-for="(item, i) in option.rateTexts"
              :key="i" :lable="i"
              :class="{select: currentIndex.indexOf(item.rateCode) !== -1}"
              @click="chooseScore(item,i, index)">
                {{ item.text }}
              </div>
              </div>
              <!-- 如果评分低于6分及以下 -->
              <div v-if="option.rateValue > 0 && option.rateValue <= rageScore" class="low-score">
              <!-- 无单选 -->
              <div v-if="!option.item" class="score-field">
                <van-field v-model="option.content" type="textarea" :placeholder="option.contentTitle" autosize clearable></van-field>
              </div>

              <!-- 有输入框 -->
              <div v-if="option.starType === 'input' && option.item">
                <van-radio-group class="van-radio-box" v-model="option.index" @change="option.content = ''">
                  <van-radio class="radio"
                      v-for="(item, i) in option.item"
                      :key="i"
                      :name="i"
                      :label="i">
                    <div class="bg-radio-box">
                      {{ item.optionName }}
                    </div>
                  </van-radio>
                </van-radio-group>
                <van-field v-model="option.content"
                    class="field-input"
                    type="textarea"
                    v-show="option.item && option.index === option.item.length - 1"
                    :placeholder="option.tip"
                    clearable
                    autosize>
                </van-field>
              </div>
              <div class="van-radio-box" v-if="option.starType === 'radio'">
                <!-- 没有输入框的直接显示单选框 -->
                  <van-radio class="radio" v-model="option.index" v-for="(item, i) in option.item" :key="i" :name="i">
                    <div class="bg-radio-box">
                      {{ item.optionName }}
                    </div>
                  </van-radio>
              </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="submit-btn">
        <van-button :loading="loading" type="info" size="normal" round @click="handleSubmit">提 交</van-button>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
      <div class="msg-text">感谢您参与本次问卷</div>
      <div class="msg-text" style="margin-top: 5px;">奖励积分已发放至您的账户</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>

    <van-popup v-model="popShow2" class="msg-pop msg-pop-join" :close-on-click-overlay="false">
      <div class="msg-text">您已参加过本次问卷调查</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
    <!-- 弹窗-不能参加 -->
    <van-popup v-model="popShow3" class="msg-pop msg-pop-error" :close-on-click-overlay="false">
      <div class="msg-text">本活动仅限IAM和OES客户参加</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回首页</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { Toast } from 'vant'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  name: 'Questionnaire',
  data () {
    return {
      loading: false,
      clientCode: '',
      optionList: [
        {
          title: '您目前的工作职能是？',
          questionCode: '001-01',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-01-01', optionName: '技工' },
            { optionCode: '001-01-02', optionName: '站长' },
            { optionCode: '001-01-03', optionName: '采购' },
            { optionCode: '001-01-04', optionName: '前台' },
            { optionCode: '001-01-05', optionName: '销售' },
            { optionCode: '001-01-06', optionName: '老板' },
            { optionCode: '001-01-07', optionName: '管理人员' }
          ]
        },
        {
          title: '您觉得目前易加网的操作界面是否友好？',
          questionCode: '001-02',
          questionType: '03',
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请告知您认为缺失的功能',
          starType: 'input',
          selectedOptionCode: '',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '2-1', text: '1分' },
            { rateCode: '2-2', text: '2分' },
            { rateCode: '2-3', text: '3分' },
            { rateCode: '2-4', text: '4分' },
            { rateCode: '2-5', text: '5分' },
            { rateCode: '2-6', text: '6分' },
            { rateCode: '2-7', text: '7分' },
            { rateCode: '2-8', text: '8分' },
            { rateCode: '2-9', text: '9分' },
            { rateCode: '2-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-02-01', optionName: '界面不美观' },
            { optionCode: '001-02-02', optionName: '功能不好找' },
            { optionCode: '001-02-03', optionName: '搜索功能不人性化' },
            { optionCode: '001-02-04', optionName: '功能缺失' }
          ]
        },
        {
          title: '您目前最常用的易加网功能有：',
          questionCode: '001-03',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-03-01', optionName: '兑换促销品' },
            { optionCode: '001-03-02', optionName: '查询配件匹配信息' },
            { optionCode: '001-03-03', optionName: '防伪查询' },
            { optionCode: '001-03-04', optionName: '查看促销信息' },
            { optionCode: '001-03-05', optionName: '参加培训' }
          ]
        },
        {
          title: '您访问易加网的主要目的是什么？',
          questionCode: '001-04',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-04-01', optionName: '查看易加网的消息' },
            { optionCode: '001-04-02', optionName: '查看“月度奖励”' },
            { optionCode: '001-04-03', optionName: '检查我的积分帐户' },
            { optionCode: '001-04-04', optionName: '寻求更多积分获取机会' },
            { optionCode: '001-04-05', optionName: '兑换积分' }
          ]
        },
        {
          title: '您对易加网微信公众号的总体满意度为',
          questionCode: '001-05',
          questionType: '03',
          rateValue: -1,
          index: -1,
          content: '',
          tip: '请告知其他原因',
          starType: 'input',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '5-1', text: '1分' },
            { rateCode: '5-2', text: '2分' },
            { rateCode: '5-3', text: '3分' },
            { rateCode: '5-4', text: '4分' },
            { rateCode: '5-5', text: '5分' },
            { rateCode: '5-6', text: '6分' },
            { rateCode: '5-7', text: '7分' },
            { rateCode: '5-8', text: '8分' },
            { rateCode: '5-9', text: '9分' },
            { rateCode: '5-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-05-01', optionName: '客服反馈不及时有效' },
            { optionCode: '001-05-02', optionName: '推送的文章没意思' },
            { optionCode: '001-05-03', optionName: '互动性不够' },
            { optionCode: '001-05-04', optionName: '其他' }
          ]
        },
        {
          title: '您对易加网微信公众号推送的内容最愿意点击查看的类别是',
          questionCode: '001-06',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-06-01', optionName: '易加礼品介绍' },
            { optionCode: '001-06-02', optionName: '近期活动介绍' },
            { optionCode: '001-06-03', optionName: '行业动态' },
            { optionCode: '001-06-04', optionName: '互动游戏' }
          ]
        },
        {
          title: '您通常更愿意通过网页还是微信来使用易加网',
          questionCode: '001-07',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-07-01', optionName: '网页' },
            { optionCode: '001-07-02', optionName: '微信' },
            { optionCode: '001-07-03', optionName: 'APP' }
          ]
        },
        {
          title: '您一般通过什么渠道了解到博世品牌产品促销？',
          questionCode: '001-08',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-08-01', optionName: '博世销售' },
            { optionCode: '001-08-02', optionName: '经销商推广' },
            { optionCode: '001-08-03', optionName: '客户会议' },
            { optionCode: '001-08-04', optionName: '博世相关网站/微信号' },
            { optionCode: '001-08-05', optionName: '易加网' }
          ]
        },
        {
          title: '您对易加网的价值偏好是？',
          questionCode: '001-09',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-09-01', optionName: '我通常会先累计积分，再进行高价值商品兑换' },
            { optionCode: '001-09-02', optionName: '我通常喜欢使用积分兑换相对价值较低的商品' }
          ]
        },
        {
          title: '您对目前易加网的促销品选择总体满意度为',
          questionCode: '001-10',
          questionType: '03',
          rateValue: -1,
          index: -1,
          starType: 'radio',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '10-1', text: '1分' },
            { rateCode: '10-2', text: '2分' },
            { rateCode: '10-3', text: '3分' },
            { rateCode: '10-4', text: '4分' },
            { rateCode: '10-5', text: '5分' },
            { rateCode: '10-6', text: '6分' },
            { rateCode: '10-7', text: '7分' },
            { rateCode: '10-8', text: '8分' },
            { rateCode: '10-9', text: '9分' },
            { rateCode: '10-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-09-01', optionName: '高价值礼品太少' },
            { optionCode: '001-09-02', optionName: '低价值礼品太少' },
            { optionCode: '001-09-03', optionName: '缺货' },
            { optionCode: '001-09-04', optionName: '新品更新频率低' }
          ]
        },
        {
          title: '您在易加网兑换的促销品主要用于？',
          questionCode: '001-11',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-11-01', optionName: '站内自用' },
            { optionCode: '001-11-02', optionName: '再次销售' },
            { optionCode: '001-11-03', optionName: '赠送进厂车主' },
            { optionCode: '001-11-04', optionName: '激励修理工' }
          ]
        },
        {
          title: '您多久在易加网进行一次积分兑换？',
          questionCode: '001-12',
          questionType: '01',
          index: -1,
          selectedOptionCode: '',
          item: [
            { optionCode: '001-12-01', optionName: '每月' },
            { optionCode: '001-12-02', optionName: '每季度' },
            { optionCode: '001-12-03', optionName: '每年只有1-2次' },
            { optionCode: '001-12-04', optionName: '只有在它们快要过期的时候' }
          ]
        },
        {
          title: '您认为我们额外的奖励组合有多大的吸引力？',
          questionCode: '001-13',
          questionType: '03',
          rateStar: true,
          rateValue: 0,
          rateTexts: ['1星', '2星', '3星', '4星', '5星']
        },
        {
          title: '目前易加网的品类中您最常兑换的是什么？',
          questionCode: '001-14',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-14-01', optionName: '维修工具' },
            { optionCode: '001-14-02', optionName: '衣物' },
            { optionCode: '001-14-03', optionName: '礼品' },
            { optionCode: '001-14-04', optionName: '产品POS物料' },
            { optionCode: '001-14-05', optionName: '博世产品' },
            { optionCode: '001-14-06', optionName: '培训' }
          ]
        },
        {
          title: '您对产品POS物料的倾向性为',
          questionCode: '001-15',
          questionType: '01',
          questionAnswer: '',
          index: -1,
          content: '',
          tip: '请告知其他倾向',
          starType: 'input',
          item: [
            { optionCode: '001-15-01', optionName: '纸质品' },
            { optionCode: '001-15-02', optionName: '维修工具' },
            { optionCode: '001-15-03', optionName: '展架' },
            { optionCode: '001-15-04', optionName: '其他' }
          ]
        },
        {
          title: '您最常兑换的促销品积分区间为',
          questionCode: '001-16',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-16-01', optionName: '1000分以下' },
            { optionCode: '001-16-02', optionName: '1000-5000' },
            { optionCode: '001-16-03', optionName: '5000-10000' },
            { optionCode: '001-16-04', optionName: '10000-30000' },
            { optionCode: '001-16-05', optionName: '30000以上' }
          ]
        },
        {
          title: '易加网于2021年新增了多个礼品类型，您是否知道？',
          questionCode: '001-17',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-17-01', optionName: '知道' },
            { optionCode: '001-17-02', optionName: '没注意' },
            { optionCode: '001-17-03', optionName: '不知道' }
          ]
        },

        // {
        //   title: '您更喜欢哪种类型的奖励？',
        //   questionCode: '001-18',
        //   questionType: '04',
        //   isRank: true,
        //   order: '',
        //   item: [
        //     { optionCode: '001-18-01', optionName: '车间工具和车间设备' },
        //     { optionCode: '001-18-02', optionName: '车间消耗品（座套、地垫、汽车罩等）' },
        //     { optionCode: '001-18-03', optionName: '技术文献参考' },
        //     { optionCode: '001-18-04', optionName: '培训/训练' },
        //     { optionCode: '001-18-05', optionName: '品牌宣传品（海报、横幅、销售点材料）' }
        //   ]
        // },

        {
          title: '您更喜欢哪种类型的奖励？(请按优先级依次输入数字1-5)',
          questionCode: '001-18',
          questionType: '02',
          isRank: true,
          list: [],
          item: [
            { optionCode: '001-18-01', optionName: '车间工具和车间设备' },
            { optionCode: '001-18-02', optionName: '车间消耗品（座套、地垫、汽车罩等）' },
            { optionCode: '001-18-03', optionName: '技术文献参考' },
            { optionCode: '001-18-04', optionName: '培训/训练' },
            { optionCode: '001-18-05', optionName: '品牌宣传品（海报、横幅、销售点材料）' }
          ]
        },

        {
          title: '我们应该提供哪些额外类型的“专业用途”奖励？',
          questionCode: '001-19',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入意见或建议',
          optionCode: '001-19-01',
          starType: ''
        },
        {
          title: '您为谁选择奖励产品？',
          questionCode: '001-20',
          questionType: '01',
          questionAnswer: '',
          index: -1,
          content: '',
          tip: '请告知其他倾向',
          starType: 'input',
          item: [
            { optionCode: '001-20-01', optionName: '主要是给我的员工作为对他们贡献的奖励' },
            { optionCode: '001-20-02', optionName: '主要是为了我的客户' },
            { optionCode: '001-20-03', optionName: '其他' }
          ]
        },
        {
          title: '您对易加网目前的扫码得积分活动的喜爱程度为',
          questionCode: '001-21',
          questionType: '03',
          rateValue: -1,
          index: -1,
          starType: 'radio',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '21-1', text: '1分' },
            { rateCode: '21-2', text: '2分' },
            { rateCode: '21-3', text: '3分' },
            { rateCode: '21-4', text: '4分' },
            { rateCode: '21-5', text: '5分' },
            { rateCode: '21-6', text: '6分' },
            { rateCode: '21-7', text: '7分' },
            { rateCode: '21-8', text: '8分' },
            { rateCode: '21-9', text: '9分' },
            { rateCode: '21-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-21-01', optionName: '操作不便利' },
            { optionCode: '001-21-02', optionName: '积分量吸引力小' },
            { optionCode: '001-21-03', optionName: '活动规则不了解' },
            { optionCode: '001-21-04', optionName: '产品包装上找不到防伪码' }
          ]
        },
        {
          title: '易加网的促销活动是否会影响您的兑换决定？',
          questionCode: '001-22',
          questionType: '03',
          rateValue: -1,
          index: -1,
          starType: 'radio',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '22-1', text: '1分' },
            { rateCode: '22-2', text: '2分' },
            { rateCode: '22-3', text: '3分' },
            { rateCode: '22-4', text: '4分' },
            { rateCode: '22-5', text: '5分' },
            { rateCode: '22-6', text: '6分' },
            { rateCode: '22-7', text: '7分' },
            { rateCode: '22-8', text: '8分' },
            { rateCode: '22-9', text: '9分' },
            { rateCode: '22-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-22-01', optionName: '对礼品价格不敏感' },
            { optionCode: '001-22-02', optionName: '促销不实惠' },
            { optionCode: '001-22-03', optionName: '促销频率太低' },
            { optionCode: '001-22-04', optionName: '主要根据业务需求兑换' }
          ]
        },
        {
          title: '您更倾向于参加哪种形式的礼品促销？',
          questionCode: '001-23',
          questionType: '02',
          list: [],
          item: [
            { optionCode: '001-23-01', optionName: '秒杀' },
            { optionCode: '001-23-02', optionName: '满减' },
            { optionCode: '001-23-03', optionName: '抽奖' },
            { optionCode: '001-23-04', optionName: '返券' }
          ]
        },
        {
          title: '您是否会由于易加网提供的服务而愿意优先选择博世配件？',
          questionCode: '001-24',
          questionType: '03',
          rateValue: -1,
          index: -1,
          content: '',
          tip: '举例1-2个品牌',
          starType: 'input',
          selectedRateCode: '',
          rateTexts: [
            { rateCode: '24-1', text: '1分' },
            { rateCode: '24-2', text: '2分' },
            { rateCode: '24-3', text: '3分' },
            { rateCode: '24-4', text: '4分' },
            { rateCode: '24-5', text: '5分' },
            { rateCode: '24-6', text: '6分' },
            { rateCode: '24-7', text: '7分' },
            { rateCode: '24-8', text: '8分' },
            { rateCode: '24-9', text: '9分' },
            { rateCode: '24-10', text: '10分' }
          ],
          item: [
            { optionCode: '001-24-01', optionName: '不知道易加网是干什么的' },
            { optionCode: '001-24-02', optionName: '积分兑换麻烦' },
            { optionCode: '001-24-03', optionName: '支持力度太小无所谓' },
            { optionCode: '001-24-04', optionName: '别的品牌也有类似项目' }
          ]
        },
        {
          title: '您觉得目前易加网在哪个方面做的最好？',
          questionCode: '001-25',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-25-01', optionName: '操作便利' },
            { optionCode: '001-25-02', optionName: '礼品选择' },
            { optionCode: '001-25-03', optionName: '物流客服' },
            { optionCode: '001-25-04', optionName: '功能多，实用' }
          ]
        },
        {
          title: '您觉得目前易加网在哪个方面做的最不好？',
          questionCode: '001-26',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-26-01', optionName: '操作便利度' },
            { optionCode: '001-26-02', optionName: '礼品选择' },
            { optionCode: '001-26-03', optionName: '物流客服' },
            { optionCode: '001-26-04', optionName: '功能性，实用性' }
          ]
        },
        {
          title: '您向其他相关人员推荐eXtra的可能性有多大？',
          questionCode: '001-27',
          questionType: '03',
          rateValue: -1,
          contentTitle: '您不推荐的主要原因是？',
          isSlider: true,
          content: '',
          tip: '请告知原因',
          optionCode: '001-21-01',
          starType: 'input',
          selectedRateCode: ''
        },
        {
          title: '我们感谢您的反馈。 请让我们知道您认为我们应该改进的地方',
          questionCode: '001-28',
          questionType: '04',
          questionAdvice: '',
          tip: '请输入意见或建议',
          optionCode: '001-28-01',
          starType: ''
        },
        {
          title: '您全年的营业额约为？',
          questionCode: '001-29',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-29-01', optionName: '30w以下' },
            { optionCode: '001-29-02', optionName: '30-50w' },
            { optionCode: '001-29-03', optionName: '50-100w' },
            { optionCode: '001-29-04', optionName: '100w以上' }
          ]
        },
        {
          title: '您全年采购博世品牌配件的金额约为多少？',
          questionCode: '001-30',
          questionType: '01',
          index: -1,
          item: [
            { optionCode: '001-30-01', optionName: '2w以下' },
            { optionCode: '001-30-02', optionName: '2-10w' },
            { optionCode: '001-30-03', optionName: '10-20w' },
            { optionCode: '001-30-04', optionName: '20w以上' }
          ]
        },
        {
          title: '以下博世对修理厂的方案您听说过哪些？',
          questionCode: '001-31',
          questionType: '02',
          index: -1,
          list: [],
          item: [
            { optionCode: '001-31-01', optionName: 'A计划' },
            { optionCode: '001-31-02', optionName: 'D/H计划' },
            { optionCode: '001-31-03', optionName: 'BSS' },
            { optionCode: '001-31-04', optionName: '没听说过' }
          ]
        }
      ],
      initList: [],
      rageScore: 6,
      // rateTexts: ['1分', '2分', '3分', '4分', '5分', '6分', '7分', '8分', '9分', '10分'],
      userInfo: {},
      popShow: false,
      popShow2: false,
      popShow3: false,
      currentIndex: [],
      currentRadio: [],
      count: 0,
      rankObj: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.initList = []
      this.resetForm(this.initList, this.optionList)

      this.userInfo = userUtils.getClientInfo()
      if (!this.userInfo) {
        this.$router.push({
          name: 'login',
          params: {
            redirectUrl: 'questionnaire'
          }
        })
      } else {
        if (!this.userInfo.isActivated) {
          window.location.href = commonUtils.getExtraSite() + '/#/activation_step_one'
          return
        }
        this.isCanJoin()
      }
    },
    isCanJoin () {
      const marketArr = ['IAM', 'OES']
      if (marketArr.indexOf(this.userInfo.marketName) === -1) {
        this.popShow3 = true
      } else {
        this.popShow3 = false
        this.isJoined()
      }
    },
    isJoined () {
      const questionnaireCode = '003'
      activityApi.isJoinedQuestionnaire(questionnaireCode).then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.questionnaireRecordList.length) {
            this.popShow2 = true
          } else {
            this.popShow2 = false
          }
        }
      })
    },
    typeText (type, isRank) {
      if (isRank) {
        return '排序'
      } else {
        switch (type) {
          case '01': return '单选'
          case '02': return '多选'
          case '03': return '单选'
        }
      }
    },

    /** 选择分数 */
    chooseScore (item, i, index) {
      this.currentIndex = []
      this.optionList[index].selectedRateCode = item.rateCode
      this.optionList.forEach(item => {
        if (item.selectedRateCode) {
          this.currentIndex.push(item.selectedRateCode)
        }
      })
      this.optionList[index].rateValue = i + 1
    },

    handleInputChange (e, index, i) {
      let value = e.target.value
      let arr = ['1', '2', '3', '4', '5']
      let arrList = []
      for (let item in this.rankObj) {
        // console.log(this.rankObj[i]);
        arrList.push(this.rankObj[item])
      }
      if (arr.indexOf(value) === -1 && value !== '') {
        Toast.fail(`请输入1~5间的数字`)
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
      } else if (arrList.indexOf(value) !== -1 && value !== '') {
        Toast.fail('输入数字重复')
        this.optionList[index].item[i].value = ''
        this.rankObj[i] = ''
        arrList[i] = ''
        // e.target.value = ''
      } else if (value === '') {
        this.rankObj[i] = ''
        arrList[i] = ''
      } else {
        this.rankObj[i] = value
      }
    },

    handleSubmit () {
      const params = {
        questionnaireCode: '003',
        clientCode: this.clientCode,
        questionnaireList: []
      }
      let flag = false
      for (let j = 0; j < this.optionList.length; j++) {
        // 单选
        if (this.optionList[j].questionType === '01' && !this.optionList[j].starType) {
          if (this.optionList[j].index < 0) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
            optionName: this.optionList[j].item[this.optionList[j].index].optionName,
            questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
            optionDesc: ''
          })
        }

        // 单选中有文本框
        if (this.optionList[j].questionType === '01' && this.optionList[j].starType === 'input') {
          if (this.optionList[j].index < 0 || (this.optionList[j].index === '3' && !this.optionList[j].content)) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          // 如果选择单选框
          if (this.optionList[j].index >= 0 && !this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].index].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].index].optionName,
              optionDesc: ''
            })
          }
          // 如果选择填写文本框
          if (this.optionList[j].content) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
              optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              questionAnswer: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
              optionDesc: this.optionList[j].content
            })
          }
        }

        // 多选
        if (this.optionList[j].questionType === '02') {
          // 排序
          if (this.optionList[j].isRank) {
            // console.log(this.optionList[j])
            for (let i of this.optionList[j].item) {
              if (!i.value) {
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                break
              }
            }
            this.optionList[j].item.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: i.optionCode,
                optionName: i.optionName,
                questionAnswer: i.value,
                optionDesc: ''
              })
            })
          } else {
            if (!this.optionList[j].list.length) {
              Toast.fail(`第${j + 1}题必填`)
              flag = true
              break
            }
            this.optionList[j].list.forEach(i => {
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[i].optionCode,
                optionName: this.optionList[j].item[i].optionName,
                questionAnswer: this.optionList[j].item[i].optionName,
                optionDesc: ''
              })
            })
          }
        }

        // 问答
        if (this.optionList[j].questionType === '04' && !this.optionList[j].isRank) {
          if (this.optionList[j].questionAdvice === '') {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: this.optionList[j].optionCode,
            optionName: this.optionList[j].tip,
            questionAnswer: this.optionList[j].questionAdvice,
            optionDesc: ''
          })
        }

        // 排序
        // if (this.optionList[j].questionType === '04' && this.optionList[j].isRank) {
        //   if (this.count !== 5) {
        //     Toast.fail(`第${j + 1}题必填`)
        //     flag = true
        //     break
        //   }
        //   params.questionnaireList.push({
        //     questionCode: this.optionList[j].questionCode,
        //     questionType: this.optionList[j].questionType,
        //     optionCode: this.optionList[j].optionCode,
        //     optionName: this.optionList[j].order,
        //     questionAnswer: this.optionList[j].order,
        //     optionDesc: ''
        //   })
        // }

        // 评分 满分10分
        if (this.optionList[j].questionType === '03' && !this.optionList[j].rateStar) {
          if (!this.optionList[j].rateValue) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          // 只有评分没有选项
          if (this.optionList[j].rateValue > this.rageScore || this.optionList[j].isSlider) {
            params.questionnaireList.push({
              questionCode: this.optionList[j].questionCode,
              questionType: this.optionList[j].questionType,
              optionCode: '',
              optionName: '',
              questionAnswer: this.optionList[j].rateValue,
              optionDesc: ''
            })
          }

          if (this.optionList[j].rateValue <= this.rageScore && !this.optionList[j].isSlider) {
            // 全是单选
            if (this.optionList[j].starType === 'radio') {
              if (this.optionList[j].index < 0) {
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                break
              }
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
                optionName: this.optionList[j].item[this.optionList[j].index].optionName,
                questionAnswer: this.optionList[j].rateValue,
                optionDesc: ''
              })
            }

            // 单选加文本
            if (this.optionList[j].starType === 'input' && this.optionList[j].item) {
              if (this.optionList[j].index < 0 || (this.optionList[j].index === '3' && !this.optionList[j].content)) {
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                break
              }
              // 如果选择单选框
              if (this.optionList[j].index >= 0 && !this.optionList[j].content) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].index].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].index].optionName,
                  questionAnswer: this.optionList[j].rateValue,
                  optionDesc: ''
                })
              }
              // 如果选择填写文本框
              if (this.optionList[j].content) {
                params.questionnaireList.push({
                  questionCode: this.optionList[j].questionCode,
                  questionType: this.optionList[j].questionType,
                  optionCode: this.optionList[j].item[this.optionList[j].item.length - 1].optionCode,
                  optionName: this.optionList[j].item[this.optionList[j].item.length - 1].optionName,
                  questionAnswer: this.optionList[j].rateValue,
                  optionDesc: this.optionList[j].content
                })
              }
            }

            // 纯文本
            if (this.optionList[j].starType === 'input' && !this.optionList[j].item) {
              if (!this.optionList[j].content) {
                Toast.fail(`第${j + 1}题必填`)
                flag = true
                break
              }
              params.questionnaireList.push({
                questionCode: this.optionList[j].questionCode,
                questionType: this.optionList[j].questionType,
                optionCode: this.optionList[j].optionCode,
                optionName: this.optionList[j].tip,
                questionAnswer: this.optionList[j].rateValue,
                optionDesc: this.optionList[j].content
              })
            }
          }
        }
        // 评分 满分5分
        if (this.optionList[j].questionType === '03' && this.optionList[j].rateStar && !this.optionList[j].isSlider) {
          if (this.optionList[j].rateValue === 0) {
            Toast.fail(`第${j + 1}题必填`)
            flag = true
            break
          }
          params.questionnaireList.push({
            questionCode: this.optionList[j].questionCode,
            questionType: this.optionList[j].questionType,
            optionCode: '',
            optionName: '',
            questionAnswer: this.optionList[j].rateValue,
            optionDesc: ''
          })
        }
        // 评分 滑块
        // if (this.optionList[j].questionType === '03' && !this.optionList[j].rateStar && this.optionList[j].isSlider) {
        //   console.log(111)
        //   if (this.optionList[j].rateValue === 0) {
        //     Toast.fail(`第${j + 1}题必填`)
        //     flag = true
        //     break
        //   }
        //   params.questionnaireList.push({
        //     questionCode: this.optionList[j].questionCode,
        //     questionType: this.optionList[j].questionType,
        //     optionCode: '',
        //     optionName: '',
        //     questionAnswer: this.optionList[j].rateValue,
        //     optionDesc: ''
        //   })
        // }
      }
      if (flag) {
        return
      }
      console.log(params)
      this.loading = true
      activityApi.submitQuestionnaire(params).then(response => {
        if (response.data.resultCode === '0') {
          this.popShow = true
          this.clientCode = ''
        } else {
          Toast.fail(response.data.resultMsg)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetForm (initArr, optionArr) {
      optionArr.forEach(option => {
        const obj = Object.assign({}, option)
        initArr.push(obj)
      })
    },
    handleRateChange (option) {
      if (option.questionAnswer > this.rageScore - 1) {
        option.index = -1
        option.content = ''
      }
    },
    popJump () {
      window.location.href = commonUtils.getExtraSite() + '/#/tab/home'
    },
    // 排序
    // handleRank (option, item) {
    //   this.count = 0
    //   item.choosed = !item.choosed
    //   for (let i of option.item) {
    //     if (i.choosed) {
    //       this.count += 1
    //     }
    //   }
    //   if (item.choosed) {
    //     this.$set(item, 'rank', this.count)
    //   } else {
    //     if (item.rank !== (this.count + 1)) {
    //       for (let i of option.item) {
    //         if (i.rank) {
    //           this.$delete(i, 'rank')
    //           this.$delete(i, 'choosed')
    //         }
    //       }
    //     } else {
    //       this.$delete(item, 'rank')
    //     }
    //   }

    //   if (this.count === 5) {
    //     for (let i of option.item) {
    //       option.order += i.rank
    //     }
    //   }
    // },
    onChange (value) {
      Toast('当前值：' + value)
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 0;
  background: #fff;
  /deep/ .van-radio__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-checkbox__icon--checked {
    .van-icon {
      border-color: #117281;
      background-color: #117281;
    }
  }
  /deep/ .van-radio__label {
    color: #333;
  }

    /deep/ .van-rate__item {
    i {
      color: #117281 !important;
    }
  }
  img {
    width: 100%;
  }
}
.title-icon {
  position: relative;
  width: 12%;
  text-align: center;
  span {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
  }
}
.content {
  padding: 15px;
  background: #f1f1f1;
  .bar_title {
    display: flex;
    .title {
      position: relative;
      flex: 1;
      padding-left: 10px;
      vertical-align: middle;
      span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .questionType {
      width: 15%;
      padding: 10px;
      line-height: 1.5;
      text-align: center;
      color: #247181;
    }
  }
  .van-radio {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .van-checkbox {
    display: inline-flex;
    padding: 0 10px 8px 0;
  }
  .content_title {
    margin: 10px 0;
  }
}
.submit-btn {
  padding: 14px 0 24px;
  text-align: center;
  .van-button {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: #117281;
    border: none;
  }
}
.msg-pop {
  width: 200px;
  height: 135px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
  .msg-text {
    font-size: 14px;
    margin-top: 10px;
    color: #402d26;
    line-height: 22px;
  }
  .msg-btn {
    margin: auto;
    margin-top: 8px;
    width: 90px;
    height: 35px;
    border-radius: 8px;
    line-height: 35px;
    font-size: 14px;
  }
}
.msg-pop-join {
  height: 110px;
}
.msg-pop-error {
  width: 220px;
  height: 110px;
}
.score-content {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
}
.score {
  display: inline-block;
  width: 9%;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  background: #f1f1f1;
  border: 1px solid #cccccc;
  cursor: pointer;
}
.select {
  background-image: linear-gradient(#3b8c96, #23565d);
  color: #ffffff;
}
.content_title {
  padding: 0 15px;
}
.low-score {
  padding: 0 10px 10px 10px;
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 12px;
}
.van-radio {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.bg-radio-box {
  position: absolute;
  width: 158px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding-left: 45px;
}
.van-radio-box .van-radio {
  width: 158px;
  padding: 0;
  border: 1px solid #f5f5f5;
}
.van-radio .van-radio__label {
  margin-left: 0px;
}
.radio {
  position: relative;
  height: 20px;
  margin-bottom: 10px;
  background: #f7f7f7;
}
.radio-input {
  background: #f7f7f7;
  .van-radio__icon {
    display: none;
  }
}
.field-input {
  width: 100%;
  font-size: 12px;
  background: #f7f7f7;
  padding: 0px 0px 10px 0px;
}
</style>
<style>
.full-radio .van-radio__label {
  flex: 1;
}
.full-radio .van-cell {
  background: #f1f1f1;
  border-radius: 5px;
}
.van-radio .van-radio__icon {
  z-index: 10;
}
.radio-input .van-radio__icon {
  display: none;
}
.van-radio__icon--checked + .van-radio__label > .bg-radio-box{
  background-image: linear-gradient(#3b8c96, #23565d);;
  color: #fff;
}
.van-radio__icon--checked .van-icon {
  border-color: #ffffff !important;
}
.field-input .van-field__control,
.score-field .van-field__control {
  height: auto !important;
}

.rate-score {
    margin-bottom: 8px;
    padding: 20px 20px;
  }
.rate-evaluation {
    position: relative;
    top: -4px;
    right: 0vw;
    color: #117281;
  }
  .rank{
    height: 50px;
    line-height: 30px;
  }
  .optionName{
    position: absolute;
    top: 2.5px;
    display: inline-block;
    left: 15px;
  }
  .rank-box{
    display: inline-block;
    position:absolute;
    top: 5px;
    width: 18px;
    height: 18px;
    border: 1px solid rgb(196, 196, 196);
    text-align: center;
    line-height: 18px;
  }
  .slider{
    height: 50px;
    margin:20px ;
  }
  .van-slider__bar{
    background-color: #117281;
  }
  .slider-text{
    font-size: 12px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }
  .rank-input{
    position: absolute;
    top: -5px;
    left: 72vw;
    display: inline-block;
  }
  .rank-input .van-cell{
    display: inline-block;
    padding: 0;
    width: 15px;
    position: relative;
    top: 7px;
  }
</style>
